import { useAppSelector } from "store/hooks";
import { selectAllSearchParams } from "store/selectors/inboxSelectors";

const useSelectedPageSearchParams = () => {
  const allSearchParams = useAppSelector(selectAllSearchParams);

  const getSelectedPageSearchParams = (
    selectedPageType: keyof typeof allSearchParams
  ) => {
    const hoveredPageSearchParams = allSearchParams?.[selectedPageType];

    const paramsString = hoveredPageSearchParams
      ? Object.keys(hoveredPageSearchParams).reduce((acc, param) => {
          if (
            param === "t" ||
            !(hoveredPageSearchParams as any)[param]?.length
          ) {
            return acc;
          }
          return `${acc}&${param}=${(hoveredPageSearchParams as any)[param]}`;
        }, "")
      : "";

    return paramsString;
  };

  return { getSelectedPageSearchParams };
};

export default useSelectedPageSearchParams;
